










































































































import { mutate } from 'array-move'
import { Guid } from 'guid-typescript'
import { snakeCase } from 'lodash'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { ValidationObserver } from 'vee-validate'
import { Component, VModel, Watch, Prop, Mixins } from 'vue-property-decorator'

import FieldTitle from '../../../../components/Pi/components/FieldTitle.vue'
import Tags from '../../../../components/Tags/Tags.vue'
import DrawerWidthMixin from '../../../../logic/helpers/DrawerWidthMixin'
import { errorNotificationWrapper } from '../../../../logic/helpers/NotificationService'
import Accordion from '../../../Accordion/Accordion.vue'
import Button, { ButtonStruct } from '../ButtonsConstructor/buttons'
import ButtonsBuildManager from './ButtonsBuildManager.vue'
import ButtonsBuildManagerPhone from './ButtonsBuildManagerPhone.vue'
import ButtonsManager from './ButtonsManager'
import AddButton from './components/AddButton.vue'
import ButtonHeader from './components/ButtonHeader.vue'
import ButtonViewWrapper from './components/ButtonViewWrapper/ButtonViewWrapper.vue'
import { ButtonsConstructorProps } from './mixins/mixins'
import {
  ButtonsRow,
  ButtonsRows,
  MoveDirection,
} from './types'

@Component({
  components: {
    ButtonsBuildManagerPhone,
    ButtonsBuildManager,
    Tags,
    FieldTitle,
    AddButton,
    ButtonViewWrapper,
    Accordion,
    ValidationObserver,
    ButtonHeader,
  },
  data: () => ({
    MoveDirection,
    snakeCase,
    isMobile,
  }),
})
export default class ButtonsConstructor extends Mixins<ButtonsConstructorProps, DrawerWidthMixin>(ButtonsConstructorProps, DrawerWidthMixin) {
  @VModel({ type: Array }) buttons!: Array<Array<ButtonStruct>>

  @Prop() removeButtonsCallback!: (data: any) => Promise<void>

  @Watch('managerIsOpen')
  isPopupOpenWatcher(val: boolean): void {
    if (!val && !this.buttonsRows[this.buttonsRows.length - 1].data.length) {
      this.buttonsRows.splice(this.buttonsRows.length - 1, 1)
    }
  }

  @Watch('buttonsRows', { deep: true })
  onButtonsRowsUpdate(buttonsRows: ButtonsRows): void {
    this.buttons = buttonsRows.map((row: ButtonsRow) => row.data)
  }

  buttonsRows: ButtonsRows = []

  currentRowGuid: string | null = null

  buttonData: Button | null = null

  managerIsOpen = false

  get buttonsManager(): ButtonsManager {
    return new ButtonsManager(this.availableButtonsTypes, this.$i18n)
  }

  selectRow(guid: string): void {
    this.currentRowGuid = guid
    this.managerIsOpen = true
  }

  addRow(): void {
    const newGuid = Guid.create().toString()

    this.buttonsRows.push({
      guid: newGuid,
      data: [],
    })

    this.currentRowGuid = newGuid
    this.managerIsOpen = true
  }

  deleteRow(guid: string): void {
    const row = this.buttonsRows.find((r) => r.guid === guid)

    if (row) {
      const deleteAction = () => this.buttonsRows.splice(this.buttonsRows.indexOf(row), 1)

      if (row.data.length && this.removeButtonsCallback) {
        this.removeButtonsCallback(row.data)
        .then(deleteAction)
        .catch((e) => errorNotificationWrapper(this.$t('error').toString(), e))
      } else {
        deleteAction()
      }
    }
  }

  addButton(struct: ButtonStruct): void {
    const row = this.buttonsRows.find((r) => r.guid === this.currentRowGuid)

    if (row) {
      row.data.push(struct)

      this.managerIsOpen = false
      this.buttonData = null
      this.currentRowGuid = null
    }
  }

  deleteButton(guid: string, button: ButtonStruct): void {
    const deleteAction = () => {
      const row = this.buttonsRows.find((r) => r.guid === guid)

      if (row) {
        row.data.splice(row.data.indexOf(button), 1)
      }
    }

    if (this.removeButtonsCallback) {
      this.removeButtonsCallback([ button ])
        .then(deleteAction)
        .catch((e) => errorNotificationWrapper(this.$t('error').toString(), e))
    } else {
      deleteAction()
    }
  }

  moveItem(src: Array<any>, index: number, direction: MoveDirection): void {
    const to = direction === MoveDirection.Forward ? index + 1 : index - 1
    mutate(src, index, to)
  }

  updateButton(rowGuid: string, struct: ButtonStruct): void {
    const row = this.buttonsRows.find((r) => r.guid === rowGuid)

    if (row) {
      const index = row.data.findIndex((b) => b.guid === struct.guid)

      if (index !== -1) {
        row.data.splice(index, 1, struct)
      }
    }
  }

  created(): void {
    this.buttonsRows = this.buttons.map((row) => {
      return {
        guid: Guid.create().toString(),
        data: row
      }
    })
  }
}
